import { render, staticRenderFns } from "./details.modal.vue?vue&type=template&id=3275147e&scoped=true"
import script from "./details.modal.vue?vue&type=script&lang=js"
export * from "./details.modal.vue?vue&type=script&lang=js"
import style0 from "./details.modal.vue?vue&type=style&index=0&id=3275147e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275147e",
  null
  
)

export default component.exports